import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	Form,
	Button,
	InputGroup,
	FloatingLabel,
	Row,
	Col,
} from 'react-bootstrap';
import Loader from '../components/Loader';
import Message from '../components/Message';
import FormContainer from '../components/FormContainer';
import { registerUser } from '../actions/userActions';
import '../styles/login-register.css';

const RegisterPage = ({ location, history }) => {
	const [typePassword, setTypePassword] = useState('password');
	const [typeConfirmPassword, setTypeConfirmPassword] = useState('password');

	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [storeName, setStoreName] = useState('');
	const [email, setEmail] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [country, setCountry] = useState('');
	const [state, setState] = useState('');
	const [region, setRegion] = useState('');
	const [address, setAddress] = useState('');
	const [description, setDescription] = useState('');
	const [message, setMessage] = useState(null);
	const dispatch = useDispatch();

	const redirect = location.search ? location.search.split('=')[1] : '';
	const userRegister = useSelector((state) => state.userRegister);
	const { loading, userInfo, error } = userRegister;

	useEffect(() => {
		if (userInfo) {
			console.log('REGISTER PAGE')
			localStorage.setItem('promptEmailVerfication', 'true');
			history.push(redirect);
		}
	}, [history, redirect, userInfo]);

	const showHidePassword = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setTypePassword(typePassword === 'password' ? 'text' : 'password');
	};
	const showHideConfirmPassword = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setTypeConfirmPassword(
			typeConfirmPassword === 'password' ? 'text' : 'password'
		);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (password !== confirmPassword) {
			setMessage('Passwords do not match. Please retry.');
		} else {
			console.log('DISPATCH REGISTER')
			dispatch(registerUser( 
				firstName,
				lastName,
				storeName,
				email,
				phoneNumber,
				password,
				country,
				state,
				region,
				address,
				description
			));
			console.log('DISPATCHED')
		}
	};

	return (
		<FormContainer>
			<div className='form-inner-container'>
				<div className='form-heading'>
					<h1 onClick={() => history.push('/login')}>Sign In</h1>
					<h1
						style={{
							background: 'ghostwhite',
							boxShadow: '0px 0px 9px 0px rgba(0, 0, 0, 0.2)',
							WebkitBoxShadow:
								'0px 0px 9px 0px rgba(0, 0, 0, 0.2)',
							MozBoxShadow: '0px 0px 9px 0px rgba(0, 0, 0, 0.2)',
						}}
						onClick={() => history.push('/register')}>
						Create Store
					</h1>
				</div>
				{message && (
					<Message dismissible variant='warning' duration={10}>
						{message}
					</Message>
				)}
				{error && (
					<Message dismissible variant='danger' duration={10}>
						{error}
					</Message>
				)}
				{loading ? (
					<Loader />
				) : (
					<Form onSubmit={handleSubmit}>
						<Form.Group controlId='firstName' className='mb-2'>
							<FloatingLabel
								controlId='firstName'
								label='First name'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Enter first name'
									type='text'
									value={firstName}
									onChange={(e) => setFirstName(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						<Form.Group controlId='name' className='mb-2'>
							<FloatingLabel
								controlId='lastName'
								label='Last name'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Enter last name'
									type='text'
									value={lastName}
									onChange={(e) => setLastName(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						<Form.Group controlId='storeName' className='mb-2'>
							<FloatingLabel
								controlId='storeName'
								label='Store name'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Enter store name'
									type='text'
									value={storeName}
									onChange={(e) => setStoreName(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						
						<Form.Group controlId='email' className='my-2'>
							<FloatingLabel
								controlId='email'
								label='Email Address'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Enter email address'
									type='email'
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>

						<Form.Group controlId='phoneNumber' className='my-2'>
							<FloatingLabel
								controlId='phoneNumber'
								label='Phone number'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Enter phone number'
									type='phoneNumber'
									value={phoneNumber}
									onChange={(e) => setPhoneNumber(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						
						<Form.Group>
							<InputGroup>
								<FloatingLabel
									controlId='password'
									label='Password'
									style={{
										display: 'flex',
										width: '100%',
									}}
									className='mb-3'>
									<Form.Control
										size='lg'
										type={typePassword}
										placeholder='Enter your password'
										value={password}
										style={{
											borderRight: 'none',
										}}
										onChange={(e) =>
											setPassword(e.target.value)
										}
									/>
									<div className='input-group-append'>
										<InputGroup.Text
											onClick={showHidePassword}
											style={{
												fontSize: '1rem',
												height: '100%',
												marginLeft: '-0.5em',
												background: 'transparent',
												borderLeft: 'none',
											}}>
											{typePassword === 'text' ? (
												<i className='far fa-eye-slash' />
											) : (
												<i className='far fa-eye' />
											)}
										</InputGroup.Text>
									</div>
								</FloatingLabel>
							</InputGroup>
						</Form.Group>
						<Form.Group>
							<InputGroup>
								<FloatingLabel
									controlId='confirmPassword'
									label='Confirm password'
									style={{ display: 'flex', width: '100%' }}
									className='mb-3'>
									<Form.Control
										size='lg'
										type={typeConfirmPassword}
										placeholder='Confirm your password'
										value={confirmPassword}
										style={{
											borderRight: 'none',
										}}
										onChange={(e) =>
											setConfirmPassword(e.target.value)
										}
									/>
									<div className='input-group-append'>
										<InputGroup.Text
											onClick={showHideConfirmPassword}
											style={{
												fontSize: '1rem',
												height: '100%',
												marginLeft: '-0.5em',
												background: 'transparent',
												borderLeft: 'none',
											}}>
											{typeConfirmPassword === 'text' ? (
												<i className='far fa-eye-slash' />
											) : (
												<i className='far fa-eye' />
											)}
										</InputGroup.Text>
									</div>
								</FloatingLabel>
							</InputGroup>
						</Form.Group>
						<Form.Group controlId='country' className='mb-2'>
							<FloatingLabel
								controlId='country'
								label='Country'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Select country'
									type='text'
									value={country}
									onChange={(e) => setCountry(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						<Form.Group controlId='state' className='mb-2'>
							<FloatingLabel
								controlId='state'
								label='State'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Select state'
									type='text'
									value={state}
									onChange={(e) => setState(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						<Form.Group controlId='region' className='mb-2'>
							<FloatingLabel
								controlId='region'
								label='Region'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Select region'
									type='text'
									value={region}
									onChange={(e) => setRegion(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						<Form.Group controlId='address' className='mb-2'>
							<FloatingLabel
								controlId='address'
								label='Address'
								className='mb-3'>
								<Form.Control
									size='lg'
									placeholder='Enter address'
									type='text'
									value={address}
									onChange={(e) => setAddress(e.target.value)}
								/>
							</FloatingLabel>
						</Form.Group>
						
						<Form.Group className="mb-3" controlId="description">
    						<Form.Label>Description</Form.Label>
    						<Form.Control 
								as="textarea" 
								rows={5} 
								size='lg'
								placeholder='Description'
								value={description}
								onChange={(e) => setDescription(e.target.value)}
/>
								
  						</Form.Group>
						<Row>
							<Col
								style={{
									display: 'flex',
								}}>
								<Button
									type='submit'
									className='ms-auto'
									style={{
										padding: '0.5em 1em',
										width: '8rem',
										backgroundColor: 'green',
										border: 'none'
									}}>
									Create Store
								</Button>
							</Col>
						</Row>
					</Form>
				)}
			</div>
		</FormContainer>
	);
};

export default RegisterPage;
